export default () => {
  const checkoutSteps = document.querySelector('.js-checkout-steps');
  if (!checkoutSteps) return;

  // Parent
  const billingFirstnameParent = document.querySelector(`#billing_first_name_field`);
  const billingLastnameParent = document.querySelector(`#billing_last_name_field`);
  const billingAddressParent = document.querySelector(`#billing_address_1_field`);
  const billingPostcodeParent = document.querySelector(`#billing_postcode_field`);
  const billingCityParent = document.querySelector(`#billing_city_field`);
  const billingCompanyParent = document.querySelector(`#billing_company_field`);
  const shippingCompanyParent = document.querySelector(`#shipping_company_field`);
  const billingCountryParent = document.querySelector(`#billing_country_field`);
  const billingPhoneParent = document.querySelector(`#billing_phone_field`);
  const billingEmailParent = document.querySelector(`#billing_email_field`);

  const shippingFirstnameParent = document.querySelector(`#shipping_first_name_field`);
  const shippingLastnameParent = document.querySelector(`#shipping_last_name_field`);
  const shippingAddressParent = document.querySelector(`#shipping_address_1_field`);
  const shippingPostcodeParent = document.querySelector(`#shipping_postcode_field`);
  const shippingCityParent = document.querySelector(`#shipping_city_field`);
  const shippingCountryParent = document.querySelector(`#shipping_country_field`);
  
  // Input field
  const billingFirstname = document.querySelector(`#billing_first_name`);
  const billingLastname = document.querySelector(`#billing_last_name`);
  const billingAddress = document.querySelector(`#billing_address_1`);
  const billingPostcode = document.querySelector(`#billing_postcode`);
  const billingCity = document.querySelector(`#billing_city`);
  const billingCountry = document.querySelector(`#billing_country`);
  const billingPhone = document.querySelector(`#billing_phone`);
  const billingEmail = document.querySelector(`#billing_email`);
  const billingCompany = document.querySelector(`#billing_company`);

  const shippingFirstname = document.querySelector(`#shipping_first_name`);
  const shippingLastname = document.querySelector(`#shipping_last_name`);
  const shippingAddress = document.querySelector(`#shipping_address_1`);
  const shippingPostcode = document.querySelector(`#shipping_postcode`);
  const shippingCity = document.querySelector(`#shipping_city`);
  const shippingCountry = document.querySelector(`#shipping_country`);
  const shippingCompany = document.querySelector(`#shipping_company`);

  setTimeout(() => {
    if (billingPostcodeParent && billingPostcodeParent.classList.contains('woocommerce-invalid')) {
        billingPostcodeParent.classList.remove('woocommerce-invalid');
        billingPostcodeParent.classList.remove('woocommerce-invalid-required-field');
    }
  }, 500);

  if (billingFirstname.value) billingFirstnameParent.classList.add('focus');
  if (billingLastname.value) billingLastnameParent.classList.add('focus');
  if (billingAddress.value) billingAddressParent.classList.add('focus');
  if (billingPostcode.value) billingPostcodeParent.classList.add('focus');
  if (billingCity.value) billingCityParent.classList.add('focus');
  if (billingCountry.value) billingCountryParent.classList.add('focus');
  if (billingPhone.value) billingPhoneParent.classList.add('focus');
  if (billingEmail.value) billingEmailParent.classList.add('focus');
  if (billingCompany.value) billingCompanyParent.classList.add('focus');

  if (shippingFirstname.value) shippingFirstnameParent.classList.add('focus');
  if (shippingLastname.value) shippingLastnameParent.classList.add('focus');
  if (shippingAddress.value) shippingAddressParent.classList.add('focus');
  if (shippingPostcode.value) shippingPostcodeParent.classList.add('focus');
  if (shippingCity.value) shippingCityParent.classList.add('focus');
  if (shippingCountry.value) shippingCountryParent.classList.add('focus');
  if (shippingCompany.value) shippingCompanyParent.classList.add('focus');
}


// WEBPACK FOOTER //
// ./src/js/modules/CheckoutFieldFocus.js